import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api";
import usePermissions from "../hooks/usePermissions";
import { API_BASE_URL, API_URL } from "../../config";
import axios from "axios";
import { toast } from "react-toastify";
import Loader from "../../Loader/loader";
import TableLoader from "../../Loader/TableLoader";
import Swal from "sweetalert2";
import { authHeaders,getSessionToken } from "../utils/session";
import { apiMessage } from "../utils/apiError";

const ManageContentPage = () => {
  const { canCreate, canEdit, canDelete } = usePermissions("/cms/managecontentpage");

  const [managePageData, setManagePageData] = useState([]);
  const [token, setToken] = useState(getSessionToken());
  const [status, setStatus] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    setToken(getSessionToken());
    loadContent();
  }, []);

  const loadContent = async () => {
    setIsLoading(true);
    await axios
      .get(`${API_BASE_URL}/get-page-and-content`, {
        headers: {
          ...authHeaders(),
          "content-type": "multipart/form-data",
        },
      })
      .then((response) => {
        setManagePageData(response.data?.data.reverse());
        setIsLoading(false);
      })
      .catch((error) => {
        setIsLoading(false);
        toast.error(apiMessage(error));
      });
  };
  const handleDelete = async (id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Do you want to delete this page? This action cannot be undone.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Delete",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#d33",
    });
    if (!result.isConfirmed) return;

    {
      setIsLoading(true);
      let body ={
        id : id,
        delete_for : 'manage_page_content'
      }

      axios
        .post(`${API_BASE_URL}/delete-tabuler-data`, body, {
          headers: {
            ...authHeaders(),
          },
        })
        .then((response) => {
          if (response.data.status === 200) {
            toast.success("Deleted successfully");
            setIsLoading(false);

            axios
              .get(`${API_BASE_URL}/get-page-and-content`, {
                headers: {
                  ...authHeaders(),
                },
              })
              .then((response) => {
                setManagePageData(response.data?.data.reverse());
              })
              .catch((error) => {
                toast.error(apiMessage(error));
                setIsLoading(false);
              });
          }
        });
    }
  };

  const handleActive = async (status, id) => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: status == 1 ? "Do you want to deactivate this page?" : "Do you want to activate this page?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: status == 1 ? "Yes, Deactivate" : "Yes, Activate",
      cancelButtonText: "Cancel",
      confirmButtonColor: status == 1 ? "#d33" : "#3085d6",
    });
    if (!result.isConfirmed) return;

    let updatedStatus = status == 0 ? 1 : 0;
    setIsLoading(true);

    const res = await axios.post(
      `${API_BASE_URL}/manage-page-contant-status`,
      { status: updatedStatus, id: id },
      {
        headers: {
          ...authHeaders(),
        },
      }
    );
    const response = JSON.parse(JSON.stringify(res));
    // console.log(response);
    if (response.data.status === 200) {
      setIsLoading(false);

      loadContent();
      if (status == 1) {
        toast.success("Inactive successfully");
      } else {
        toast.success("Active successfully");
      }
    }
  };

  // const handleActive = async (status, id) => {
  //   let updatedStatus = status == 0 ? 1 : 0;
  //    await axios.post(
  //     `${API_BASE_URL}/update-page-content-status?id=${id}&status=${updatedStatus}`,{
  //       headers: {
  //         Authorization: `Bearer ${token}`,
  //         "content-type": "multipart/form-data",
  //       },
  //     })
  //     .then((response) => {
  //       console.log(response);
  //       if (response.data.status === 200) {
  //         loadContent();
  //         if (status == 1) {
  //           toast.success("Active successfully");
  //         } else {
  //           toast.success("Inactive successfully");
  //         }
  //       }
  //     })
  //     .catch((error) => {
  //       console.log(error);
  //     });

  // };

  return (
    <>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0 font-size-18">Manage Content Page </h4>

                  <div className="page-title-right">
                    <ol className="breadcrumb m-0">
                      <li className="breadcrumb-item">
                        <a href="javascript: void(0);">CMS</a>
                      </li>
                      <li className="breadcrumb-item active">
                        Manage Content Page
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>
            {/* <div className="row justify-content-end">
              <div className="col-lg-12 mb-2 ">
                <Link
                  to={"/cms/managecontentpage/addcontentpage"}
                  data-repeater-create
                  type="button"
                  className="btn btn-success inner"
                  value="Add Number"
                >
                  Add <i className="fa fa-plus ms-1"></i>
                </Link>
              </div>
            </div> */}

            <div className="row">
              <div className="col-lg-12">
                <div className="card">
                  <div className="card-body">
                  <div className="d-flex justify-content-between align-items-center mb-2">
                  <h4 className="card-title">
                      Content Page List ({managePageData?.length})
                    </h4>
                {canCreate && (
                <Link
                  to={"/cms/managecontentpage/addcontentpage"}
                  data-repeater-create
                  type="button"
                  className="btn btn-success inner"
                  value="Add Number"
                >
                  Add <i className="fa fa-plus ms-1"></i>
                </Link>
                )}
              </div>
                   
               
                      <div className="table-responsive">
                        <table className="table align-middle table-nowrap mb-0">
                          <thead className="table-light">
                            <tr>
                              {/* <th styles="width: 20px;">
                                <div className="form-check font-size-16 align-middle">
                                  <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="transactionCheck01"
                                  />
                                  <label
                                    className="form-check-label"
                                    for="transactionCheck01"
                                  ></label>
                                </div>
                              </th> */}
                              <th className="align-middle">Page Name</th>
                              <th className="align-middle">Page URL</th>

                              {/* <th className="align-middle">Description</th> */}
                              {/* <th className="align-middle">
                            Page Slider Description
                          </th> */}
                              {/* <th className="align-middle">Image</th> */}
                              <th className="align-middle">Status</th>
                              <th className="align-middle">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {isLoading ? 
                            <TableLoader count={3} /> :  
                            managePageData?.length  > 0 ?                      
                           ( managePageData?.map((item) => (
                              <tr>
                                {/* <td>
                                  <div className="form-check font-size-16">
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      id="transactionCheck02"
                                    />
                                    <label
                                      className="form-check-label"
                                      for="transactionCheck02"
                                    ></label>
                                  </div>
                                </td> */}
                                <td>
                                  <a
                                    href="javascript: void(0);"
                                    className="text-body fw-bold"
                                  >
                                    {item.page_name}
                                  </a>
                                </td>
                                <td>
                                  <a
                                    href="javascript: void(0);"
                                    className="text-body fw-bold"
                                  >
                                    {item.page_url}
                                  </a>
                                </td>
                                {/* <td>{item.page_id}</td>
                            <td>page name</td> */}
                                {/* <td className="text-wrap ">
                                <div
                                  style={{
                                    height: "150px",
                                    overflow: "hidden",
                                  }}
                                >
                                  {item.page_content}
                                </div>
                              </td> */}
                                {/* <td>
                               
                                <img
                                  class="card-img-top  rounded "
                                  src={item.image}
                                  alt="Card image cap"
                                  width="30"
                                  height="65"
                                />
                              </td>  */}
                                <td>
                                  {item.status == 1 ? (
                                    <span className="badge badge-pill badge-soft-success font-size-11">
                                      Active
                                    </span>
                                  ) : (
                                    <span className="badge badge-pill badge-soft-danger font-size-11">
                                      Inactive
                                    </span>
                                  )}
                                </td>

                                <td>
                                  {canEdit && (
                                  <Link
                                    to={`/cms/managecontentpage/addcontentpage/${item.id}`}
                                    type="button"
                                    className="btn btn-primary btn-sm btn-rounded waves-effect waves-light"
                                  >
                                    <i className="fa fa-pen"></i>
                                  </Link>
                                  )}
                                  {canDelete && (
                                  <button
                                    type="button"
                                    className="btn btn-danger btn-sm btn-rounded waves-effect waves-light ms-2"
                                    onClick={() => {
                                      handleDelete(item.id);
                                    }}
                                  >
                                    <i className="fa fa-trash"></i>
                                  </button>
                                  )}

                                  <button
                                    type="button"
                                    className="btn btn-warning btn-sm btn-rounded  ms-2"
                                    onClick={() => {
                                      setStatus(item.status === 0 ? 1 : 0);
                                      handleActive(item.status, item.id);
                                    }}
                                  >
                                    <i className="fa fa-ban"></i>
                                  </button>
                                </td>
                              </tr>
                            ))) : 
                            (
                              <tr>
                                <td colSpan="11">
                                  <div
                                    style={{
                                      textAlign: "center",
                                      fontSize: "18px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    No Data Found
                                  </div>
                                </td>
                              </tr>
                            )
                           }
                          </tbody>
                        </table>
                      </div>
               
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageContentPage;
